import React from 'react';
import CategoryTemplate from "../../components/templates/CategoryTemplate";

export const CategoryAdd = () => <CategoryTemplate type={'ADD'}/>;
